export const isValidEntityId = (entityId: unknown): boolean => !(entityId === 0 || isNaN(entityId as number))
